import React, { useState } from "react";
import PricePlans from "./PriceComponent/PricePlans";
import ComparePlans from "./PriceComponent/ComparePlan";
import BusinessPromoCard from "./PriceComponent/BusinessPromotionCard";
import FreeTrialCard from "./PriceComponent/FreeTrialCard";

const PriceBooking = () => {
  return (
    <>
      <PricePlans />
      <BusinessPromoCard />
      <ComparePlans />
      <FreeTrialCard />
    </>
  );
};

export default PriceBooking;
